import React from 'react';
import { Select } from '@td-client-frontend/common';
import ComponentWrapperRHF from './ComponentWrapperRHF';

interface Props {
  name: string;
  label: string;
  options: Record<'label' | 'value', string>[];
  placeholder?: string;
  wrapperClasses?: string;
  labelBtnType?: string;
  labelBtn?: () => void;
  required?: boolean;
  requiredIf?: string[];
  readOnlyFieldFormatter?: (value: any, options?: any) => void;
  isLoading?: boolean;
}

export const SelectRhf = ({ ...props }: Props) => {
  return (
    <ComponentWrapperRHF {...props}>
      <Select />
    </ComponentWrapperRHF>
  );
};
